<template id="buy-box">
  <div class="row">
    <img :src="item.img_url" class="min-width:160px;"/>
    <h4>{{item.title}}</h4>
    <p>$ {{item.price}}</p>
    <div class="qty-minus" v-on:click="minusQty(item)">-</div>
    <div class="qty">{{item.qty}}</div>
    <div class="qty-plus" v-on:click="plusQty(item)">+</div>
    <div class="del" v-on:click="removeItem(item)">Remove</div>
    <div class="totalprice">{{item.total}}</div>
  </div>
</template>

<script>
export default {
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props:{
        item:{
            type: Object,
            default(){
                return {}
            }
        }
    },
}
</script>

<style lang="scss" scoped>

.row {
    width: 100%;
    border-bottom: 1px solid #BFBFBF;
    overflow: hidden;
    padding: 10px 0;
    display: block;
    float: left;

    img {
        height: 100px;
        float: left;
    }
    h4 {
        float: left;
        margin: 0;
        line-height: 100px;
        margin-left: 20px;
        width: 100px;
    }
    p {
        float: left;
        margin: 0;
        width: 80px;
        line-height: 100px;
        margin-left: 35px;
        text-align: center;
    }
    .qty-minus {
        float: left;
        width: 20px;
        line-height: 100px;
        margin-left: 60px;
        text-align: center;
        cursor: pointer;
    }
    .qty {
        float: left;
        width: 20px;
        line-height: 100px;
        margin-left: 20px;
        text-align: center;
    }
    .qty-plus {
        float: left;
        width: 20px;
        line-height: 100px;
        margin-left: 20px;
        text-align: center;
        cursor: pointer;
    }
    .del {
        float: left;
        width: 80px;
        line-height: 100px;
        margin-left: 60px;
        cursor: pointer;
        text-decoration: underline;
        color: #ED277F;
    }
    .totalprice {
        float: left;
        width: 80px;
        line-height: 100px;
        margin-left: 10px;
        text-align: right;
    }
    .row p::before, .box p::before, .totalprice::before {
        content: "$";
    }
}
</style>